import React from 'react';

const SubmissionComments = () => {
    return (
        <div className="submission-comments-container">
            <div className="content-section">
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
            Can I update my profile?
            </h3> 
                <p>Ensuring Correct Submission: Comment Section</p>
                <p className="description">
                    This guide outlines the steps to ensure that your submission is correctly added to the system. If you encounter any issues, please reach out to the <strong>Help Desk</strong> for support.
                </p>

                {/* Step 1 */}
                <h3 className="step-heading">Step 1: Navigate to the Submission Module</h3>
                <p className="description">
                    Open the dashboard. <br />
                    Click on Submissions in the left-hand menu. <br />
                    You will be taken to the Submission Sheet page.
                </p>

                {/* Step 2 */}
                <h3 className="step-heading">Step 2: Open the Submission Entry Sheet</h3>
                <p className="description">
                    On the Submission Sheet page, locate the Add button on the top right-hand side. <br />
                    Click the Add button to open the Submission Entry Sheet.
                </p>
                <img
                    src="  https://res.cloudinary.com/danfpnuui/image/upload/v1737966318/1_jwxnw3.png"
                    alt="Submission Comments Guide"
                    className="placeholder-image"
                    style={{ width: '700px', height: 'auto', margin: '20px block' }} // Reduce image size
                />
                {/* Step 3 */}
                <h3 className="step-heading">Step 3: Fill Out the Submission Entry Form</h3>
                <p className="description">
                    <strong>Consultant and Client Information</strong><br />
                    Click the Consultant Name tab. <br />
                    A dropdown list will appear. Select the consultant's name. <br />
                    Click the Client Name tab. <br />
                    A dropdown list will appear. Select the client’s name. <br />
                    <strong>Vendor Details</strong><br />
                    Enter the Vendor Name in the appropriate field. <br />
                    Enter the Vendor Email Address in the provided field. <br />
                    Type the Vendor Mobile Number in the designated box. <br />
                    (Optional) If there is a secondary number, enter it in the Secondary Number field. <br />
                    <strong>Payment and Submission Details</strong><br />
                    Enter the Pay Rate in the respective field. <br />
                    (Optional) Fill in the Submitted For field if applicable. If not, leave this field blank. <br />
                    Type your name in the Submitted By field. <br />
                    <strong>Requirements and Status</strong><br />
                    Click on the Requirement Tab. A dropdown menu will appear. Select the candidate's preferred method of communication. <br />
                    Click on the Status Tab. A dropdown menu will appear. Select the consultant's current status. <br />
                    <strong>Job Type</strong><br />
                    Click on the Job Type Tab. A dropdown menu will appear. Select the relevant job type.
                </p>
                <img
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737638586/WhatsApp_Image_2025-01-23_at_4.55.07_PM_nfufwa.jpg"
                    alt="Submission Comments Guide"
                    className="placeholder-image"
                    style={{ width: '700px', height: 'auto', margin: '20px block' }} // Reduce image size
                />
                {/* Step 4 */}
                <h3 className="step-heading">Step 4: Save Your Submission</h3>
                <p className="description">
                    Review all the entered details for accuracy. <br />
                    Click the Save button to save the form. <br />
                    This process ensures the submission is added correctly to the system. If you encounter any issues, contact the Help Desk for support.
                </p>
                  <h4> Follow for Commenting Section</h4>
                {/* Additional Steps */}
                <h3 className="step-heading">Step 1: Accessing Consultant Details</h3>
                <p className="description">
                    Navigate to the Consultant’s Profile. <br />
                    To begin, locate the consultant’s name or email address within the system. <br />
                    Click on the consultant’s name or email to access their profile.
                </p>

                <h3 className="step-heading">Step 2: Navigating to the Submission Comments Section</h3>
                <p className="description">
                    View the Submission Comments. <br />
                    After selecting the consultant, you will be directed to the Submission Comments section. <br />
                    This section allows you to communicate directly with the employer, admin, consultant, or super admin.
                </p>

                <h3 className="step-heading">Step 3: Contacting Relevant Parties</h3>
                <p className="description">
                    Message the Appropriate Parties. <br />
                    In the Submission Comments section, you can send messages to the relevant parties (employer, admin, consultant, or super admin). <br />
                    Use the message box to send any questions or comments to these individuals regarding the submission.
                </p>

                <h3 className="step-heading">Step 4: Contacting Help Desk (If Needed)</h3>
                <p className="description">
                    Reach Out for Support. <br />
                    If you encounter any issues that you are unable to resolve, please contact the Help Desk for assistance. <br />
                    The Help Desk team is available to assist with any technical or system-related issues.
                </p>

                {/* Image Section */}
                <img
                    src=" https://res.cloudinary.com/danfpnuui/image/upload/v1737966330/2_ilzgzh.png"
                    alt="Submission Comments Guide"
                    className="placeholder-image"
                    style={{ width: '700px', height: 'auto', margin: '20px block' }} // Reduce image size
                />

                <p className="help-text">
                    For any further assistance, feel free to reach out to the Help Desk for support.
                </p>
            </div>
        </div>
    );
};

export default SubmissionComments;
